import React from 'react';
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom'

import MainPage from './pages/MainPage';
import DataPrivacy from './pages/DataPrivacy';

function App() {
  return (
    
      <BrowserRouter>
        <div className='App background-container'>
          <div className='app-content'>
            <Routes>
              
              
              <Route path='/' element={<MainPage />} />
              <Route path='/data-privacy' element={<DataPrivacy />} />
              
              
            </Routes>
          </div>
        </div>
      </BrowserRouter>
  
  );
}

export default App;

